import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import card from "assets/theme/components/card";
import cardContent from "assets/theme/components/card/cardContent";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Card, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import { Link, Navigate } from "react-router-dom";

export default class Blogs extends Component {
  state = {
    secondaryCategories: [],
    per_page: 20,
    page_no: 1,
    notiColor: "success",
    notification: false,
    message: "",
    loading: false,
  };
  componentDidMount() {
    this.getAllBlogs();
  }

  getAllBlogs = () => {
    this.setState({ loading: true });
    if (init() === "success") {
      axios
        .get(Constants.getUrls.getAllBlogs)
        .then((resp) => {
          // console.log(resp.data.data);
          this.setState({
            secondaryCategories: resp.data.data.docs,
            loading: false,
          });
        })
        .catch((err) => {
          this.setState({
            notiColor: "warning",
            message: "Something went wrong!",
            notification: true,
          });
          setTimeout(() => {
            this.setState({
              notification: false,
              message: "",
              notiColor: "success",
              loading: false,
            });
          }, 3500);
        });
    } else {
      this.setState({
        loading: false,
      });
    }
  };

  updateBlogStatus = (blogId) => {
    if (init() !== "success") {
      return;
    }

    axios
      .put(`${Constants.putUrls.updateBlogStatus}${blogId}`)
      .then((resp) => {
        this.setState(
          {
            notification: true,
            notiColor: "success",
            message: resp?.data?.message || "Blog status updated successfully.",
          },
          () => {
            this.getAllBlogs();
          }
        );
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "error",
          message: err?.response?.data?.message || "Unable to update blog status.",
        });
      });

    setTimeout(() => {
      this.setState({
        notification: false,
        message: "",
      });
    }, 2500);
  };

  handleDelete = (id) => {
    if (!window.confirm("Delete this blog? This will be a soft delete.")) {
      return;
    }

    if (init() === "success") {
      axios
        .delete(`${Constants.deleteUrls.deleteBlog}${id}`)
        .then((resp) => {
          this.setState(
            {
              notification: true,
              notiColor: "success",
              message: resp?.data?.message || "Blog deleted successfully.",
            },
            () => {
              this.getAllBlogs();
            }
          );
        })
        .catch((err) => {
          this.setState({
            notification: true,
            notiColor: "error",
            message: err?.response?.data?.message || "Unable to delete blog.",
          });
        });

      setTimeout(() => {
        this.setState({
          notification: false,
          message: "",
        });
      }, 2500);
    }
  };

  applicationStatus = (job_id, status) => {
    if (init() === "success") {
      axios
        .put(Constants.putUrls.applicationStatus, { job_id, response_status: status })
        .then((resp) => {
          this.setState(
            {
              notification: true,
              noticolor: "success",
              message: resp.data.message,
            },
            () => {
              this.getAllBlogs();
            }
          );
          setTimeout(() => {
            this.setState({
              notification: false,
              message: "",
            });
          }, 2500);
        });
    }
  };

  render() {
    return (
      <div>
        <DashboardLayout>
          <DashboardNavbar />
          <MDBox pt={6} pb={3}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Blogs
                </MDTypography>
              </MDBox>
              <Grid item sm={4} px={2} align="right">
                <Link to="/addnewblogs">
                  <MDButton variant="contained" size="small" color="primary">
                    Create New
                  </MDButton>
                </Link>
              </Grid>
              <MDBox py={3}>
                {this.state.loading ? (
                  <MDBox>
                    <Grid align="center">
                      <h4>Loading...</h4>
                    </Grid>
                  </MDBox>
                ) : (
                  <>
                    {this.state.secondaryCategories.length > 0 ? (
                      <DataTable
                        table={{
                          columns: [
                            { Header: "serial", accessor: "serial", width: "6%" },
                            { Header: "title", accessor: "test_series" },
                            { Header: "type", accessor: "blog_type" },
                            { Header: "for", accessor: "blogs_for" },
                            { Header: "status", accessor: "status" },
                            { Header: "poster", accessor: "small" },
                            { Header: "action", accessor: "action" },
                          ],
                          rows: this.state.secondaryCategories.map((sec, index) => ({
                            serial: index + 1,
                            test_series: sec?.blogs_title,
                            blog_type: sec?.blog_type || "-",
                            blogs_for: sec?.blogs_for || "-",
                            status: (
                              <MDButton
                                variant="outlined"
                                size="small"
                                color={sec?.status === "active" ? "success" : "warning"}
                                onClick={() => this.updateBlogStatus(sec?._id)}
                              >
                                {sec?.status === "active" ? "Active" : "Inactive"}
                              </MDButton>
                            ),
                            small: (
                              <>
                                {sec?.blog_type === "video" ? (
                                  <img
                                    src={`https://img.youtube.com/vi/${sec.youtube_video_id}/hqdefault.jpg`}
                                    alt="YouTube Thumbnail"
                                    style={{ height: "100px", width: "250px", objectFit: "cover" }}
                                  />
                                ) : (
                                  <img
                                    src={Constants.imageDomain + sec.blogs_poster}
                                    alt="Blog Poster" // Always good to include alt text for images
                                    style={{ height: "100px", width: "250px" }}
                                  />
                                )}
                              </>
                            ),
                            action: (
                              <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
                                <Link to={`/update-blog/${sec?._id}`}>
                                  <MDButton variant="outlined" size="small" color="info">
                                    Edit
                                  </MDButton>
                                </Link>
                                <MDButton
                                  variant="outlined"
                                  size="small"
                                  color="error"
                                  onClick={() => this.handleDelete(sec?._id)}
                                >
                                  Delete
                                </MDButton>
                              </div>
                            ),

                            // status: (
                            //   <>
                            //     <FormControl fullWidth>
                            //       <InputLabel>Application Status</InputLabel>
                            //       <Select
                            //         value={sec?.response_status}
                            //         onChange={(e) => this.applicationStatus(sec.id, e.target.value)}
                            //         label="Application Status"
                            //         name="response_status"
                            //         style={{
                            //           height: "45px",
                            //           color: "red",
                            //         }}
                            //       >
                            //         <MenuItem value="pending">Pending</MenuItem>
                            //         <MenuItem value="hired">Hired</MenuItem>
                            //         <MenuItem value="rejected">Rejected</MenuItem>
                            //       </Select>
                            //     </FormControl>
                            //   </>
                            // ),
                            // action: (
                            //   <>
                            //     <Link
                            //       to={{
                            //         pathname: "/applicant-details/" + sec.user_id,
                            //         state: { data: sec },
                            //       }}
                            //     >
                            //       <MDButton variant="outlined" size="small" color="dark">
                            //         User Details
                            //       </MDButton>
                            //     </Link>
                            //   </>
                            // ),
                          })),
                        }}
                      />
                    ) : (
                      <div>No Data Found!</div>
                    )}
                  </>
                )}
              </MDBox>
              <>
                <MDSnackbar
                  color={this.state.notiColor}
                  icon="notifications"
                  title="Agriquiz"
                  content={this.state.message}
                  dateTime="Just now"
                  open={this.state.notification}
                  //   close={toggleSnackbar}
                />
              </>
            </Card>
          </MDBox>
        </DashboardLayout>
      </div>
    );
  }
}
